var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import Text from '../Text';
import colors from '../../themes/colors';
var CriticalIndicator = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n\n  &::before {\n    content: '';\n    margin-bottom: 2px;\n    margin-right: 4px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n\n  &::before {\n    content: '';\n    margin-bottom: 2px;\n    margin-right: 4px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n  }\n"])), function (_a) {
    var color = _a.color;
    return colors[color];
});
var getColor = function (variant) {
    switch (variant) {
        case 'success':
            return 'green60';
        case 'warning':
            return 'yellow80';
        case 'error':
            return 'red80';
        default:
            return 'neutral60';
    }
};
var LabelStatus = function (props) {
    var label = props.label, selectedColor = props.color, variant = props.variant;
    var color = selectedColor !== null && selectedColor !== void 0 ? selectedColor : getColor(variant);
    return (_jsx(CriticalIndicator, __assign({ color: color }, { children: _jsx(Text, __assign({ color: selectedColor ? 'neutral90' : color, variant: "tag1Semibold" }, { children: label })) })));
};
export default LabelStatus;
var templateObject_1;
